import { uurlTestToolStyle } from '@bingads-webui-campaign-react/common-styles';

export const getSmartShoppingCampaignOverrideStyles = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '.smart-shopping-settings': {
    '& .bidding-strategy__container': {
      '& .custom-param__key-field': {
        width: 85,
        display: 'inline-block',
        marginLeft: 5,
        marginRight: 5,
      },
      '& .col-sm-6': {
        width: 438,
        boxSizing: 'content-box',
        paddingTop: 5,
        '& .alert': {
          marginTop: 6,
        },
      },
    },
    '& .campaign-settings-title, & .advaced-settings-title': {
      display: 'none',
    },
    '& .adschedule-targets-container': {
      borderTop: 'none',
      '& .col-sm-2, & .col-sm-10': {
        paddingLeft: 0,
      },
      '& #adScheduleDisplayTimeLabel': {
        display: 'block',
      },
    },
    '& .advanced-settings': {
      paddingBottom: 20,
      '& .form-group': {
        marginLeft: 0,
      },
      '&>div>.form-horizontal>.form-group>a[data-target="#setAdvancedSettings"]': {
        fontSize: 18,
        marginBottom: 15,
        marginLeft: 0,
        paddingLeft: 0,
        '&:hover, &:focus': {
          border: 'none',
          textDecoration: 'none',
          backgroundColor: '#F3F2F1',
        },
      },
      ...uurlTestToolStyle({ palette, iconFontFamily }),
    },
  },
});
